import { render } from "./ComplyonAiSidebar.vue?vue&type=template&id=4bf64b5b&scoped=true"
import script from "./ComplyonAiSidebar.vue?vue&type=script&lang=js"
export * from "./ComplyonAiSidebar.vue?vue&type=script&lang=js"

import "./ComplyonAiSidebar.vue?vue&type=style&index=0&id=4bf64b5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf64b5b"]])

export default __exports__